<template>
  <div>
    <el-row :gutter="isMobile ? 10 : 20" class="status-row">
      <el-col :xs="24" :sm="8">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background:#409EFF;"><i class="el-icon-time"></i></div>
          <div class="stat-info">
            <p class="stat-label">最近爬取</p>
            <p class="stat-value">{{ latestTime || '暂无' }}</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="8">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background:#67C23A;"><i class="el-icon-document"></i></div>
          <div class="stat-info">
            <p class="stat-label">累计入库</p>
            <p class="stat-value">{{ status.totalCrawled || 0 }} 篇</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="8">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background:#E6A23C;"><i class="el-icon-s-tools"></i></div>
          <div class="stat-info">
            <p class="stat-label">执行次数</p>
            <p class="stat-value">{{ status.taskCount || 0 }} 次</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card style="margin-bottom:20px;">
      <div class="action-bar">
        <div>
          <h3 style="margin:0;">手动触发爬虫</h3>
          <p style="margin:5px 0 0;color:#909399;font-size:13px;">将立即执行一次爬取任务，从 Bing、36氪、IT之家 聚合最新AI资讯</p>
        </div>
        <el-button type="primary" icon="el-icon-position" :loading="running" @click="runCrawl">
          {{ running ? '正在爬取...' : '立即执行' }}
        </el-button>
      </div>
    </el-card>

    <el-card>
      <div slot="header"><span style="font-weight:600;">爬取历史记录</span></div>
      <el-table v-if="!isMobile" :data="tasks" border stripe v-loading="loading" style="width:100%;">
        <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
        <el-table-column prop="source" label="来源" width="120" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 'SUCCESS' ? 'success' : row.status === 'RUNNING' ? 'warning' : 'danger'" size="small">
              {{ row.status === 'SUCCESS' ? '成功' : row.status === 'RUNNING' ? '运行中' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="articleCount" label="入库" width="80" align="center">
          <template slot-scope="{ row }">{{ row.articleCount || 0 }} 篇</template>
        </el-table-column>
        <el-table-column prop="message" label="详情" min-width="250"></el-table-column>
        <el-table-column label="执行时间" width="180" align="center">
          <template slot-scope="{ row }">{{ formatTime(row.startTime) }}</template>
        </el-table-column>
        <el-table-column label="耗时" width="100" align="center">
          <template slot-scope="{ row }">{{ calcDuration(row) }}</template>
        </el-table-column>
      </el-table>

      <div v-if="isMobile" v-loading="loading">
        <div v-for="row in tasks" :key="row.id" class="mobile-task-item">
          <div class="mobile-task-top">
            <el-tag size="mini" :type="row.status === 'SUCCESS' ? 'success' : 'danger'">{{ row.status === 'SUCCESS' ? '成功' : '失败' }}</el-tag>
            <span class="mobile-task-time">{{ formatTime(row.startTime) }}</span>
          </div>
          <div class="mobile-task-msg">{{ row.message }}</div>
          <div class="mobile-task-bottom">
            <span>来源: {{ row.source }}</span>
            <span>入库: {{ row.articleCount || 0 }}篇</span>
            <span>耗时: {{ calcDuration(row) }}</span>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'AdminCrawl',
  data() {
    return {
      status: {},
      tasks: [],
      loading: false,
      running: false,
      isMobile: false
    }
  },
  computed: {
    latestTime() {
      if (!this.status.latestTask || this.status.latestTask === '无记录') return ''
      return this.formatTime(this.status.latestTask.startTime)
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.loadStatus()
    this.loadTasks()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() { this.isMobile = window.innerWidth <= 768 },
    async loadStatus() {
      const { data } = await api.getCrawlStatus()
      this.status = data
    },
    async loadTasks() {
      this.loading = true
      try {
        const { data } = await api.getCrawlTasks()
        this.tasks = data
      } finally {
        this.loading = false
      }
    },
    async runCrawl() {
      this.running = true
      try {
        const { data } = await api.runCrawl()
        this.$message.success(`爬取完成：${data.message}`)
        this.loadTasks()
        this.loadStatus()
      } catch {
        this.$message.error('爬取失败，请检查网络')
      } finally {
        this.running = false
      }
    },
    formatTime(dateStr) {
      if (!dateStr) return '-'
      const d = new Date(dateStr)
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}:${String(d.getSeconds()).padStart(2,'0')}`
    },
    calcDuration(row) {
      if (!row.startTime || !row.endTime) return '-'
      const s = new Date(row.startTime).getTime()
      const e = new Date(row.endTime).getTime()
      return Math.round((e - s) / 1000) + ' 秒'
    }
  }
}
</script>

<style scoped>
.status-row { margin-bottom: 20px; }
.stat-card {
  display: flex; align-items: center; padding: 10px 0;
}
.stat-card >>> .el-card__body { display: flex; align-items: center; gap: 15px; width: 100%; }
.stat-icon {
  width: 50px; height: 50px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 24px; color: white; flex-shrink: 0;
}
.stat-info { flex: 1; }
.stat-label { color: #909399; font-size: 13px; margin: 0; }
.stat-value { font-size: 20px; font-weight: 700; color: #303133; margin: 5px 0 0; }
.action-bar { display: flex; justify-content: space-between; align-items: center; }

.mobile-task-item {
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.mobile-task-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.mobile-task-time { font-size: 11px; color: #909399; }
.mobile-task-msg { font-size: 13px; color: #303133; margin-bottom: 6px; line-height: 1.5; }
.mobile-task-bottom {
  display: flex;
  gap: 10px;
  font-size: 11px;
  color: #909399;
}

@media screen and (max-width: 768px) {
  .status-row { margin-bottom: 15px; }
  .stat-card >>> .el-card__body { padding: 10px !important; gap: 10px; }
  .stat-icon { width: 40px; height: 40px; font-size: 20px; }
  .stat-value { font-size: 16px; }
  .action-bar { flex-direction: column; gap: 10px; align-items: flex-start; }
  .action-bar .el-button { width: 100%; }
}
</style>
